// 小屏-能耗
<template>
  <div class="DkbSTCE">
    <div class="tabBox">
      <div class="tab" v-if="WEInfo.HasE">
        <div class="left">
          <p class="tabTit">今日用电量</p>
          <p class="val">{{WEInfo.NowE}}<span class="unit">KWH</span></p>
        </div>
        <div class="right">
          <p :class="['text', {'down': WEInfo.EDValDown}]">同比昨天<span class="dVal">{{WEInfo.EDVal}}kwh</span></p>
        </div>
      </div>
      <div class="tab" v-if="WEInfo.HasW">
        <div class="left">
          <p class="tabTit">今日用水量</p>
          <p class="val">{{WEInfo.NowW}}<span class="unit">T</span></p>
        </div>
        <div class="right">
          <p :class="['text', {'down': WEInfo.WDValDown}]">同比昨天<span class="dVal">{{WEInfo.WDVal}}T</span></p>
        </div>
      </div>
    </div>
    <div class="chartBox">
      <div class="markArea">
        <div class="left">
          <span class="text" v-if="WEInfo.HasE">用电量</span>
          <span class="text water" v-if="WEInfo.HasW">用水量</span>
        </div>
        <div class="right">
          <span 
            :class="['text', {'active': item.value === nowTimeType}]"
            v-for="(item) in timeTypeList" :key="item.value" 
            @click="selectTimeType(item.value)">{{item.label}}</span>
        </div>
      </div>
      <div id="TCEChart"></div>
    </div>
  </div>
</template>

<script>
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from "../../../../static/js/utility/utility.js"
  let echarts = require('echarts')
  let vm, Timer

  export default {
    name: 'DkbSTCE',
    components: {
    },
    props: {
      // 父组件传来的参数
      sData: {
        type: Object,
        default: {}
      }
    },
    computed: {
    },
    data () {
      return {
        chartId: 'TCEChart',
        /* 水电表 */
        WEInfo: {},
        timeTypeList: [ // 时间类型，1为天，2为周，3为月
          {
            value: 1,
            label: '天'
          },
          {
            value: 2,
            label: '周'
          },
          {
            value: 3,
            label: '月'
          },
        ],
        nowTimeType: 1, // 当前显示
      }
    },
    created () {
      vm = this
      vm.WEInfo = vm.sData
      console.log('vm', vm.WEInfo)
    },
    mounted() {
      vm.drawChart()
      vm.timeRefresh()
    },
    destroyed () {
      clearInterval(Timer)
    },
    methods: {
      // 定时刷新数据
      timeRefresh () {
        Timer = setInterval(()=>{
          vm.GetTCEInfo()
        }, 1000*10*60)
      },
      // 选择时间类型
      selectTimeType (val) {
        vm.nowTimeType = val
        clearInterval(Timer)
        vm.GetTCEInfo()
        vm.timeRefresh()
      },
      // 获取能耗信息（小屏）
      async GetTCEInfo () {
        let data = { nowTimeType: vm.nowTimeType }
        let res = await dkbApi.GetTCEInfo(data)
        if (res.ErrCode === 0) {
          console.log('WEInfo', vm.WEInfo)
          vm.WEInfo = res.Result
          let {WDVal, EDVal} = res.Result
          vm.WEInfo.WDValDown = WDVal < 0
          vm.WEInfo.WDVal = Math.abs(WDVal)
          vm.WEInfo.EDValDown = EDVal < 0
          vm.WEInfo.EDVal = Math.abs(EDVal)
          vm.drawChart()
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 绘制图表
      drawChart () {
        if (vm.WEInfo.HasE || vm.WEInfo.HasW) {
          vm.$nextTick(()=>{
            vm.getMixChart() 
          })
        }
      },
      // 获取水电表混合图表数据
      getMixChartData () {
        let list = [...vm.WEInfo.List]
        let nowTimeType = vm.nowTimeType
        let xInterval = nowTimeType === 1 ? 6 : nowTimeType === 2 ? 0 : 8
        let xData = [], WValArr = [], WMaxB = 5, EValArr = [], EMaxB = 5
        list.forEach(function (item, index) {
          xData.push(item.Label)
          let WB = Math.ceil(item.WValue/10)
          if (WB > WMaxB) { WMaxB = WB}
          WValArr.push(item.WValue)
          let EB = Math.ceil(item.EValue/10)
          if (EB > EMaxB) { EMaxB = EB}
          EValArr.push(item.EValue)
        })
        let WMaxVal = WMaxB*10
        let EMaxVal = EMaxB*10
        return { xData, xInterval, WValArr, WMaxVal, EValArr, EMaxVal }
      },
      getMixChart (id) {
        // 获取数据
        let { xData, xInterval, WValArr, WMaxVal, EValArr, EMaxVal } = vm.getMixChartData()

        let myChart = echarts.init(document.getElementById(vm.chartId))
        let htmlFontSize = vm.$store.state.htmlFontSize
        let getSeriesItemStyle = function(isH){ // 设置线条样式
          let seriesItemStyle = {
                normal: {
                  opacity:0,
                  color: 'transparent',
                  borderWidth: 0,
                },
                emphasis: {
                  opacity: 1,
                  color: '#ffffff',
                  shadowColor: 'rgba(81, 193, 225, 0.58)',
                  shadowBlur: 3,
                  label: {
                    show: true,
                    position: [(10/100)*htmlFontSize, -(15/100)*htmlFontSize],
                    color: '#fff',
                    fontSize: (12/100)*htmlFontSize,
                    padding: [0, (5/100)*htmlFontSize],
                    lineHeight: (13/100)*htmlFontSize,
                    width: (34/100)*htmlFontSize,
                    height: (13/100)*htmlFontSize,
                    formatter(params) {
                      return params.data+ (isH ? 'T' : 'KWH')
                    }
                  },
                }
          }
          return seriesItemStyle
        }
        let getyAxis = function (name, valArr, interval, color, padding) { // 绘制纵坐标
          let yAxis = {
              type: 'value',
              name: name,
              nameTextStyle: {
                padding: padding,
                color: color
              },
              min: valArr[0],
              max: valArr[1],
              interval: interval,
              axisTick: { // 刻度
                show: false  // 不显示刻度
              },
              axisLine: { //坐标轴
                lineStyle: {
                  color: '#3b95b6'  // 坐标轴颜色
                }
              },
              axisLabel: { //刻度标签
                interval: 0,
                color: color,
                fontSize: (10/100)*htmlFontSize,
                formatter: '{value}',
              },
              splitLine: { //分割线
                lineStyle: {
                  color: '#1b5477'
                }
              },
              markPoint: { // 标注
                symbol: 'circle'
              }
            }
          return yAxis
        }
        let getseries = function (name, data, yAxisIndex, color) { // 绘制线条
          let series = 
            {
              name: name,
              type:'line',
              yAxisIndex: yAxisIndex,
              data: data,
              lineStyle: {
                width: (5/100)*htmlFontSize,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [{
                    offset: 0, color: color // 0% 处的颜色
                  }, {
                    offset: 1, color: '#ffffff' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              },
              label: {
                backgroundColor: {
                  image: '/static/images/dkb/NARA/tv_bg.png'
                },
              },
              itemStyle: getSeriesItemStyle()
            }
          return series
        }
        let yAxis = [], series = [], yAxisIndex = 0
        if (vm.WEInfo.HasE) { 
          yAxis.push(getyAxis('电量', [0, EMaxVal], 10, '#92bd37', [0, 0, -(5/100)*htmlFontSize, -(15/100)*htmlFontSize]))
          series.push(getseries('用电量', EValArr, yAxisIndex, '#92bd37'))
          yAxisIndex++
        }
        if (vm.WEInfo.HasW) { 
          yAxis.push(getyAxis('水量', [0, WMaxVal], 10, '#e99314', [0, -(15/100)*htmlFontSize, -(5/100)*htmlFontSize, 0]))
          series.push(getseries('用水量', WValArr, yAxisIndex, '#e99314'))
        }

        let option = {
          grid: {
            top: (45/100)*htmlFontSize,
            bottom: (10/100)*htmlFontSize,
            left: 0,
            right: 0,
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              position: 'bottom',
              // boundaryGap: true,
              data: xData,
              // 指示线
              axisPointer: {
                show: true,
                type: 'line',
                lineStyle: {
                  width: 1,
                  type: 'dashed',
                  color: '#368bac'
                },
              },
              // 刻度
              axisTick: {
                show: false  // 不显示刻度
              },
              // 坐标轴
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: '#2f7d9f'  // 坐标轴颜色
                }
              },
              axisLabel: {
                interval: xInterval,
                showMaxLabel: true,
                color: '#51c1e1',
                fontSize: (10/100)*htmlFontSize,
              }
            }
          ],
          yAxis: yAxis,
          series: series
        }
        // console.log('option', option)

        myChart.setOption(option, true)
      },
      // 屏幕变化图表自适应加载
      resizeGetChart () {
        echarts.init(document.getElementById(vm.chartId)).resize()
      }
    },
    watch: {
      // 屏幕变化，图表自适应加载
      '$store.state.isOnresize' (newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.resizeGetChart()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.DkbSTCE {
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 0.4rem;
  display: flex;
  flex-direction: column;
  .tabBox {
    flex-shrink: 0;
    display: flex;
    .tab {
      &+.tab {
        margin-left: 0.24rem;
      }
      flex: 1;
      padding: 0.15rem 0.15rem 0.15rem 0.2rem;
      background-color: #072c4e;
      box-shadow: 0.08rem 0.08rem 0.15rem rgba(13, 29, 55, 0.07) inset;
      display: flex;
      justify-content: space-between;
      .left {
        flex-shrink: 0;
        .tabTit {
          margin-bottom: 0.17rem;
          letter-spacing: 0.02rem;
          font-size: 0.14rem;
          line-height: 1;
          color: #51c1e1;
        }
        .val {
          font-size: 0.28rem;
          line-height: 1;
          .unit {
            margin-left: 0.08rem;
            font-size: 0.18rem;
            line-height: 1;
          }
        }
      }
      .right {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .text {
          font-size: 0.13rem;
          color: #58d0f8;
          background: url(/static/images/dkb/TCE/icon_top.png) 0.54rem center no-repeat;
          &.down {
            background: url(/static/images/dkb/TCE/icon_down.png) 0.54rem center no-repeat;
          }
          .dVal {
            margin-left: 0.2rem;
            font-size: 0.1rem;
            line-height: 1;
            color: #25d94b;
          }
        }
      }
    }
    
  }
  .chartBox{
    width: 100%;
    height: 100%;
    margin-top: 0.2rem;
    padding: 0.25rem 0.2rem 0.2rem;
    background-color: #072c4e;
    box-shadow: 0.08rem 0.08rem 0.15rem rgba(13, 29, 55, 0.07) inset;
    display: flex;
    flex-direction: column;
    .markArea {
      width: 100%;
      color: #c3cad9;
      font-size: 0.14rem;
      line-height: 1;
      display: flex;
      justify-content: space-between;
      .left {
        flex-shrink: 0;
        display: flex;
        .text {
          padding-left: 0.15rem;
          position: relative;
          &+.text {
            margin-left: 0.15rem;
          }
          &::before {
            display: block;
            content: '';
            width: 0.09rem;
            height: 0.09rem;
            // background-color: #0cbbe5;
            background-color: #92bd37;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
          &.water::before {
            // background-color: #ea5413;
            background-color: #e99314;
          }
        }
      }
      .right {
        flex-shrink: 0;
        display: flex;
          .text {
            padding-left: 0.14rem;
            color: #51c1e1;
            font-size: 0.12rem;
            position: relative;
            &+.text{
              margin-left: 0.12rem;
            }
            &:before{
              content: '';
              display: block;
              width: 0.07rem;
              height: 0.07rem;
              border-radius: 50%;
              box-sizing: border-box;
              border: 0.01rem solid #51c1e1;
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }
            &.active:before {
              background-color: #51c1e1;
              box-shadow: 0 0 0.03rem rgba(81, 793, 225, 0.58);
            }
          }
        // .text {
        //   padding-left: 0.14rem;
        //   position: relative;
        //   &+.text {
        //     margin-left: 0.15rem;
        //   }
        //   &::before {
        //     display: block;
        //     content: '';
        //     width: 0.1rem;
        //     height: 0.1rem;
        //     border-radius: 50%;
        //     background-color: #ffffff;
        //     // a1afbc
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //     bottom: 0;
        //     margin: auto;
        //   }
        //   &.active::after {
        //     display: block;
        //     content: '';
        //     width: 0.06rem;
        //     height: 0.06rem;
        //     border-radius: 50%;
        //     background-color: #0cbbe5;
        //     position: absolute;
        //     left: 0.02rem;
        //     top: 0;
        //     bottom: 0;
        //     margin: auto;
        //   }
        // }
      }
    }
    #TCEChart {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/TCE.vue